import styled from 'styled-components';
import colors from '../../utils/colors';

export const Content = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
`;
export const Service = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1rem;
	max-width: 400px;
	span {
		font-weight: bold;
		color: #444;
		font-size: 1.1rem;
		padding: 0.5rem 0;
	}
	p {
		color: #888;
		font-size: 1.1rem;
		text-align: center;
	}
`;
export const Container = styled.section`
	display: flex;
	flex-direction: column;
	padding: 2rem 0;
	margin: 0 auto;
`;
export const SectionButton = styled.button`
	align-self: center;
	margin: 2rem 0;

	color: ${colors.dark};
	background: transparent;
	padding: 0.5rem 1rem;
	text-transform: uppercase;
	font-size: 1rem;
	padding-left: 1.5rem;
	letter-spacing: 0.5rem;
	font-weight: 700px;
	border: 1px solid ${colors.dark};
	&:hover {
		background: ${colors.dark};
		color: ${colors.white};
		cursor: pointer;
		transition: all 0.3s linear;
	}
`;
